import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from '../environments/environment';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideRemoteConfig, getRemoteConfig } from '@angular/fire/remote-config';
import { provideAnalytics, getAnalytics, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { provideFunctions, getFunctions } from '@angular/fire/functions';
import { provideFirestore, getFirestore, enableMultiTabIndexedDbPersistence } from '@angular/fire/firestore';
import { HeaderComponent } from './header/header.component';
import { NgxMaskModule } from 'ngx-mask';
import { FooterComponent } from './footer/footer.component';
import { MainComponent } from './main/main.component';
import { ChooseServicePlanComponent } from './choose-service-plan/choose-service-plan.component';
import { ReviewVenueComponent } from './review-venue/review-venue.component';
import { VenueConfirmationComponent } from './venue-confirmation/venue-confirmation.component';
import { NavigationStepComponent } from './navigation-step/navigation-step.component';
import { SignupStepperComponent } from './signup-stepper/signup-stepper.component';
import { InputErrorListComponent } from './common/input-error-list/input-error-list.component';
import { InputErrorIconComponent } from './common/input-error-icon/input-error-icon.component';
import { LoginComponent } from './login/login.component';
import { CommonModule } from '@angular/common';
import { VenueTypeComponent } from './venue-type/venue-type.component';
import { DebugLocalStorageComponent } from './debug-local-storage/debug-local-storage.component';
import { DebugPanelComponent } from './debug-panel/debug-panel.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    MainComponent,
    ChooseServicePlanComponent,
    ReviewVenueComponent,
    VenueConfirmationComponent,
    NavigationStepComponent,
    SignupStepperComponent,
    InputErrorListComponent,
    InputErrorIconComponent,
    LoginComponent,
    VenueTypeComponent,
    DebugLocalStorageComponent,
    DebugPanelComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideFunctions(() => getFunctions()),
    provideAnalytics(() => getAnalytics()),
    provideRemoteConfig(() => {
      const config = getRemoteConfig()
      config.fetchTimeMillis = 1000
      return config
    }),
    provideFirestore(() => {
      const firestore = getFirestore();
      // The Firestore local cache IS the app's offline store: local-first
      // reads/writes, offline queueing, and multi-tab consistency.
      enableMultiTabIndexedDbPersistence(firestore).catch((error) => {
        console.warn('Firestore offline persistence unavailable:', error?.code || error);
      });
      return firestore;
    })
  ],
  providers: [
    { provide: 'REQUIRED', useValue: 'You must enter a value.' },
    ScreenTrackingService, UserTrackingService,
    { provide: 'ANALYTICS', useFactory: () => getAnalytics() }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
